import Vue from 'vue';
import Api from './index';

window.API = new Api();

Vue.prototype.$http = {
    /**
     * @description 首页 banner
     * */
    getHomeBanner: () => API.get('/banner/list'),

    /**
     * @description Search
     * @param {String} search 搜索用 [不用传sex, 默认返回8条]
     * */
    getSearchList: (params) =>
        API.get('/model/search', {
            params,
        }),

    /**
     * @description 模特列表
     * @param {String} sex 性别 [1: Men, 2: Women]
     * @param {String} search 搜索用 [不用传sex, 默认返回8条]
     * @param {String} page 页码
     * @param {String} limit
     * */
    getModelList: (params) =>
        API.get('/model/list', {
            params,
        }),

    /**
     * @description 模特详情
     * @param {String} id
     * */
    getModelDetail: (params) =>
        API.get('/model/detail', {
            params,
        }),

    /**
     * @description NEWS 列表
     * @param {String} page 页码
     * @param {String} limit
     * */
    getNewsList: (params) =>
        API.get('/new/list', {
            params,
        }),

    /**
     * @description NEWS 详情
     * @param {String} id
     * */
    getNewsDetail: (params) =>
        API.get('/new/detail', {
            params,
        }),

    /**
     * @description 联系我们
     * @param {String} id
     * */
    getContactList: () => API.get('/contact/list'),
};
